import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const InternalBackdrop = /*#__PURE__*/React.forwardRef(function InternalBackdrop(props, ref) {
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    role: "presentation"
    // Ensures Floating UI's outside press detection runs, as it considers
    // it an element that existed when the popup rendered.
    ,
    "data-floating-ui-inert": true,
    ...props,
    style: {
      position: 'fixed',
      inset: 0
    }
  });
});
process.env.NODE_ENV !== "production" ? InternalBackdrop.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
export { InternalBackdrop };